import { profileSDK } from 'Utils/ProfileSDK';
import { logger } from 'Utils/Logger';
import { capitalizeFirstLetter } from 'Utils/Format';
import { getTokenExpirations, getUser } from 'Utils/UserCookie';

//API calls from Profile SDK

export const updateUser = async (user) => {
  logger.apiRequest('update user');
  let res;
  try {
    const response = await profileSDK().update(user);
    res = response ? response : new Error();
  } catch (e) {
    logger.apiError('update user', null, e);
    res = e;
  }
  logger.apiResponse('update user');
  return res;
};

export const checkExistingUser = (email) => {
  logger.apiRequest('check existing user');
  return profileSDK().status({ email });
};

export const resetEmail = async (email) => {
  let res;
  logger.apiRequest('reset email');
  try {
    res = await profileSDK().resetPassword({ email });
    logger.apiResponse('reset email', res);
    res = res && res.message && res.message === 'Reset Email Sent' ? true : res.message;
  } catch (e) {
    const errorMessage = e.errorMessage ? `${e.statusCode}: ${capitalizeFirstLetter(e.errorMessage)}` : e.message;
    logger.apiError('reset email', null, e);
    res = errorMessage;
  }
  return res;
};

export const registerSecondScreenCode = (regCode) => {
  logger.apiRequest('register second screen code', regCode);
  return profileSDK()
    .userLoggedInOrRegistered({ regCode, isRegister: true })
    .then((res) => {
      logger.apiResponse('register second screen code', res);
      return res;
    })
    .catch((error) => {
      console.error(error.message);
      logger.apiError('register second screen code', null, error.message);
      return { error: error.message };
    });
};

export const fetchMobileRegcode = (deviceId) => {
  logger.apiRequest('fetch mobile regcode', deviceId);
  return profileSDK()
    .regCodeDeeplink({ deviceId })
    .then((res) => {
      logger.apiResponse('fetch mobile regcode', res);
      return res;
    })
    .catch((error) => {
      console.error(error.message);
      logger.apiError('fetch mobile regcode', null, error.message);
      return { error: error.message };
    });
};

export const login = ({ email, password, recaptchaToken, deviceId, mvpd, mvpdHash }) => {
  logger.apiRequest('login');
  return profileSDK()
    .login({ email, password, recaptchaToken, deviceId, mvpd, mvpdHash })
    .then((res) => {
      /*TODO: CLEAN UP */
      const expirations = getTokenExpirations(res.tokenExpiration);
      return { ...res, ...expirations };
    });
};

export const logout = async () => {
  try {
    const user = getUser();
    let { refreshToken } = user;
    logger.apiRequest('logout');
    const result = await profileSDK().logout({ refreshTokenHint: refreshToken });
    logger.apiResponse('logout', result);
    return result;
  } catch (error) {
    logger.apiError('logout', null, error.message);
    return { error: true };
  }
};

export const checkRefreshToken = ({ accessTokenExpiration, refreshToken }) => {
  logger.apiRequest('check refresh token');
  return profileSDK()
    .checkRefreshToken({ tokenExpiration: accessTokenExpiration, refreshToken })
    .then((res) => {
      logger.apiResponse('check refresh token', res);
      /*TODO: CLEAN UP */
      const expirations = getTokenExpirations(res.tokenExpiration);
      return { ...res, ...expirations };
    })
    .catch((error) => {
      console.error(error.message);
      logger.apiError('check refresh token', null, error.message);
      return { error: error.message };
    });
};

export const createPaymentAccount = async (user, recaptchaToken) => {
  const { firstName, lastName, password = '', email } = user;
  const payload = {
    CreateUserReqMessage: {
      firstName,
      lastName,
      customerUsername: email,
      customerPassword: password,
      email,
      recaptchaToken,
      isGenerateToken: false,
      dmaId: '001',
      verifyEmail: false,
      address: {
        country: 'US',
      },
    },
  };
  logger.apiRequest('create payment account', payload);
  return profileSDK()
    .createPaymentAccount(payload)
    .then((res) => {
      logger.apiResponse('create payment account', res);
      return res.CreateUserResponseMessage;
    })
    .catch((error) => {
      console.error(error);
      logger.apiError('create payment account', null, error);
      return error;
    });
};

export const updatePaymentAccount = async ({ profileId, firstName, lastName }) => {
  const payload = {
    UpdateProfileRequestMessage: {
      firstName,
      lastName,
      emailNotificationFlag: true,
    },
  };
  logger.apiRequest('update payment account', payload);
  return profileSDK()
    .updatePaymentAccount(profileId, payload)
    .then((res) => {
      logger.apiResponse('update payment account', res);
      return { updateSuccess: !!res.UpdateProfileResponseMessage };
    })
    .catch((error) => {
      console.error(error.message);
      logger.apiError('update payment account', null, error.message);
      return { error: error.message };
    });
};
